import { createTheme } from "@material-ui/core/styles"
import { colors, spacing } from "@minuthq/meatball-ui-react"

export default createTheme({
  palette: {
    primary: { main: colors.primary },
    secondary: { main: colors.neutralPrimary },
  },
  typography: {
    fontFamily: "FigTree, sans-serif",
    color: colors.textPrimary,
  },
  props: {
    MuiDialogTitle: {
      disableTypography: true,
    },
    MuiButtonGroup: {
      disableRipple: true,
      variant: "contained",
      color: "primary",
      disableElevation: true,
    },
    MuiToggleButton: {
      disableRipple: true,
    },
    MuiTab: {
      disableRipple: true,
    },
    MuiPopover: {
      elevation: 5,
    },
    MuiFormControl: {
      variant: "outlined",
    },

    MuiTooltip: {
      placement: "top",
      arrow: true,
    },
  },
  overrides: {
    MuiFormLabel: {
      root: {
        fontSize: "0.875rem",
      },
    },
    MuiInputBase: {
      root: {
        fontWeight: 500,
        fontSize: "0.875rem",
      },
    },

    MuiToggleButton: {
      root: {
        textTransform: "none",
        letterSpacing: "0px",
        color: "inherit",
      },
      label: {
        color: colors.textPrimary,
      },
    },
    MuiPaper: {
      root: {
        color: colors.textPrimary,
      },
      rounded: {
        borderRadius: "16px",
      },
    },
    MuiDialogTitle: {
      root: {
        padding: `${spacing.XL} ${spacing.XL2} ${spacing.XS}`,
        fontSize: "1.5rem",
        fontWeight: 500,
      },
    },
    MuiDialogContentText: {
      root: {
        color: "inherit",
        opacity: 0.85,
      },
    },
    MuiDialogContent: {
      root: {
        padding: `${spacing.XS} ${spacing.XL2}`,
      },
    },
    MuiDialogActions: {
      root: {
        padding: `${spacing.L}`,
        flexFlow: "wrap",
      },
    },
    MuiFormControlLabel: {
      label: {
        fontWeight: 500,
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "0.875rem",
        backgroundColor: colors.primaryLight,
        color: colors.textPrimary,
        boxShadow:
          "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        padding: "0.875rem",
        borderRadius: "16px",
      },
      arrow: {
        color: colors.primaryLight,
      },
    },
  },
})
